import { Positioning, Spacing } from "@bonusx-global/bx-design-system";
import styled from "@emotion/styled";

export const ChatbotInputContainer = styled("div")({
  position: Positioning.sticky,
  padding: `${Spacing[1000]} ${Spacing[750]}`,
  bottom: 0,
});
